import { SxProps, Theme } from '@mui/material';

export const tycBoxStylesSx: SxProps<Theme> = (theme) => ({
	[theme.breakpoints.up('md')]: {
		textAlign: 'right',
	},
});
